import Splide from '@splidejs/splide'
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'pageCounter' ]

  connect() {
    this.element.querySelectorAll('.splide__slide--clone').forEach(e => e.remove())
    this.slider = new Splide( this.element )
    if (this.hasPageCounterTarget) {
      this.slider.on('mounted', () => this.updatePageCounter())
      this.slider.on('moved', () => this.updatePageCounter())
    }
    this.slider.mount()
  }

  reload(e) {
    this.slider.refresh()
    const index = e.detail.param || 0
    this.slider.Components.Track.jump(parseInt(index))
  }

  updatePageCounter() {
    const currentSlide = this.slider.index + 1;
    const totalSlides = this.slider.length;
    this.pageCounterTarget.textContent = `${currentSlide} / ${totalSlides}`;
  }
}
